/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DispatchCallSessionsDto
 */
export interface DispatchCallSessionsDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof DispatchCallSessionsDto
     */
    callSessionIds: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof DispatchCallSessionsDto
     */
    userIds: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof DispatchCallSessionsDto
     */
    campaignId: number;
}

/**
 * Check if a given object implements the DispatchCallSessionsDto interface.
 */
export function instanceOfDispatchCallSessionsDto(value: object): value is DispatchCallSessionsDto {
    if (!('callSessionIds' in value) || value['callSessionIds'] === undefined) return false;
    if (!('userIds' in value) || value['userIds'] === undefined) return false;
    if (!('campaignId' in value) || value['campaignId'] === undefined) return false;
    return true;
}

export function DispatchCallSessionsDtoFromJSON(json: any): DispatchCallSessionsDto {
    return DispatchCallSessionsDtoFromJSONTyped(json, false);
}

export function DispatchCallSessionsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DispatchCallSessionsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'callSessionIds': json['callSessionIds'],
        'userIds': json['userIds'],
        'campaignId': json['campaignId'],
    };
}

export function DispatchCallSessionsDtoToJSON(json: any): DispatchCallSessionsDto {
    return DispatchCallSessionsDtoToJSONTyped(json, false);
}

export function DispatchCallSessionsDtoToJSONTyped(value?: DispatchCallSessionsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'callSessionIds': value['callSessionIds'],
        'userIds': value['userIds'],
        'campaignId': value['campaignId'],
    };
}

